import { calcDuration } from 'cross-state';
import { registerSW } from 'virtual:pwa-register';

const updateServiceWorker = registerSW({
  onRegistered(registration) {
    console.debug('Service worker registered');

    if (!registration) {
      return;
    }

    setInterval(
      () => {
        void registration.update();
      },
      calcDuration({ seconds: 10 }),
    );
  },

  onOfflineReady() {
    console.debug('Service worker: Offline ready');
  },

  onNeedRefresh() {
    console.debug('Service worker: Update ready');
  },
});

Object.assign(window, { updateServiceWorker });
